// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SelectFieldInline Component Styles
   Based on selectField.css — floating label removed, placeholder shown inline.
*/

:root {
  --scl--cms-components-selectFieldInline-border-color:              var(--input-defualt);
  --scl--cms-components-selectFieldInline-border-hover-color:        var(--input-hover);
  --scl--cms-components-selectFieldInline-focus-color:               #2388FF;
  --scl--cms-components-selectFieldInline-warning-color:             #FFC18E;
  --scl--cms-components-selectFieldInline-error-color:               #F8868A;
  --scl--cms-components-selectFieldInline-text-color:                var(--typography-text-body-secondary);
  --scl--cms-components-selectFieldInline-placeholder-color:         #7D8187;
  --scl--cms-components-selectFieldInline-chevron-color:             var(--input-defualt);
  --scl--cms-components-selectFieldInline-dropdown-bg:               #FFFFFF;
  --scl--cms-components-selectFieldInline-dropdown-shadow:           rgba(0, 0, 0, 0.12);
  --scl--cms-components-selectFieldInline-option-hover-bg:           var(--action-hover);
  --scl--cms-components-selectFieldInline-option-selected-bg:        rgba(125, 129, 135, 0.2);
  --scl--cms-components-selectFieldInline-required-color:            #EB5252;
  --scl--cms-components-selectFieldInline-search-border-color:       rgba(255, 255, 255, 0.05);
  --scl--cms-components-selectFieldInline-search-input-text-color:   #FFFFFF;
  --scl--cms-components-selectFieldInline-assistive-text-color:      rgba(255, 255, 255, 0.54);
  --scl--cms-components-selectFieldInline-assistive-error-color:     #FF5252;
  --scl--cms-components-selectFieldInline-scrollbar-track-bg:        #393939;
  --scl--cms-components-selectFieldInline-scrollbar-thumb-bg:        #1C1C1C;
  --scl--cms-components-selectFieldInline-scrollbar-thumb-hover-bg:  #7D8187;
}

/* ─── Container ──────────────────────────────────────────────────────────────── */

.scl--cms-components-selectFieldInline-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  width: 100%;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  position: relative;
}

/* ─── Plate ──────────────────────────────────────────────────────────────────── */

.scl--cms-components-selectFieldInline-plate {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  height: 32px;
  border: 1px solid var(--scl--cms-components-selectFieldInline-border-color);
  border-radius: 3px;
  cursor: pointer;
  transition: border-color 0.3s ease;
  position: relative;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

.scl--cms-components-selectFieldInline-plate:hover {
  border: 1px solid var(--scl--cms-components-selectFieldInline-border-hover-color);
}

/* Bottom focus accent bar */
.scl--cms-components-selectFieldInline-plate::after {
  content: '';
  position: absolute;
  left: -1px;
  bottom: -1px;
  width: calc(100% + 2px);
  height: 4px;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  background: var(--scl--cms-components-selectFieldInline-focus-color);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.scl--cms-components-selectFieldInline-plate.scl--cms-components-selectFieldInline--open::after {
  opacity: 1;
}

.scl--cms-components-selectFieldInline-plate:hover:not(.scl--cms-components-selectFieldInline--open) {
  border-color: var(--scl--cms-components-selectFieldInline-border-hover-color);
}

.scl--cms-components-selectFieldInline-plate.scl--cms-components-selectFieldInline--open {
  border-color: var(--scl--cms-components-selectFieldInline-border-hover-color);
}

.scl--cms-components-selectFieldInline-plate.scl--cms-components-selectFieldInline--warning::after {
  background: var(--scl--cms-components-selectFieldInline-warning-color);
  opacity: 1;
}

.scl--cms-components-selectFieldInline-plate.scl--cms-components-selectFieldInline--error::after {
  background: var(--scl--cms-components-selectFieldInline-error-color);
  opacity: 1;
}

.scl--cms-components-selectFieldInline-plate.scl--cms-components-selectFieldInline--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ─── Wrapper ────────────────────────────────────────────────────────────────── */

.scl--cms-components-selectFieldInline-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 12px;
  gap: 12px;
  width: 100%;
  height: 32px;
  flex: 1;
  order: 0;
  flex-grow: 1;
  box-sizing: border-box;
}

.scl--cms-components-selectFieldInline-valueWrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0;
  height: 100%;
  flex: 1;
  order: 1;
  flex-grow: 1;
}

.scl--cms-components-selectFieldInline-textWrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0px;
  width: 100%;
  height: 100%;
  flex: 1;
  order: 0;
  flex-grow: 1;
  position: relative;
}

/* ─── Selected value text ────────────────────────────────────────────────────── */

.scl--cms-components-selectFieldInline-text {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: var(--scl--default-font);
  font-style: light;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.50px;
  color: var(--input-hover);
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ─── Placeholder (replaces floating label) ──────────────────────────────────── */

.scl--cms-components-selectFieldInline-placeholder {
  font-family: var(--scl--default-font);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: var(--scl--cms-components-selectFieldInline-placeholder-color);
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
}

/* ─── Chevron ────────────────────────────────────────────────────────────────── */

.scl--cms-components-selectFieldInline-chevronIcon {
  width: 16px;
  height: 16px;
  flex: none;
  order: 1;
  transition: transform 0.3s ease, stroke 0.3s ease;
}

.scl--cms-components-selectFieldInline-chevronIcon path {
  stroke: var(--scl--cms-components-selectFieldInline-chevron-color);
  transition: stroke 0.3s ease;
}

.scl--cms-components-selectFieldInline-plate.scl--cms-components-selectFieldInline--open
.scl--cms-components-selectFieldInline-chevronIcon {
  transform: rotate(180deg);
}

/* ─── Dropdown ───────────────────────────────────────────────────────────────── */

.scl--cms-components-selectFieldInline-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  right: 0;
  background: var(--scl--cms-components-selectFieldInline-dropdown-bg);
  border-radius: 2px;
  min-width: 115px;
  max-height: 280px;
  overflow: auto;
  z-index: 1000;
  box-shadow: 0px 4px 4px var(--scl--cms-components-selectFieldInline-dropdown-shadow);
  opacity: 0;
  transform: translateY(-6px);
  transition: opacity 0.2s ease, transform 0.2s ease, visibility 0s linear 0.2s;
  pointer-events: none;
  visibility: hidden;
}

.scl--cms-components-selectFieldInline-dropdown.scl--cms-components-selectFieldInline-dropdown--open {
  opacity: 1;
  transform: translateY(0px);
  pointer-events: auto;
  visibility: visible;
  transition: opacity 0.2s ease, transform 0.2s ease, visibility 0s linear 0s;
}

/* ─── Search ─────────────────────────────────────────────────────────────────── */

.scl--cms-components-selectFieldInline-search {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 17px;
  gap: 14px;
  width: 100%;
  height: 37px;
  border-bottom: 1px solid var(--scl--cms-components-selectFieldInline-search-border-color);
}

.scl--cms-components-selectFieldInline-searchIcon {
  width: 20px;
  height: 17px;
  flex: none;
  flex-grow: 0;
}

.scl--cms-components-selectFieldInline-searchIcon path,
.scl--cms-components-selectFieldInline-searchIcon ellipse {
  stroke: var(--scl--cms-components-selectFieldInline-border-color);
}

.scl--cms-components-selectFieldInline-searchInput {
  width: 100%;
  background: transparent;
  border: none;
  outline: none;
  font-family: var(--scl--default-font);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: var(--scl--cms-components-selectFieldInline-search-input-text-color);
  padding: 0;
  flex: 1;
  flex-grow: 1;
}

.scl--cms-components-selectFieldInline-searchInput::placeholder {
  color: var(--scl--cms-components-selectFieldInline-border-color);
}

/* ─── Options ────────────────────────────────────────────────────────────────── */

.scl--cms-components-selectFieldInline-options {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 7px 0;
  gap: 0px;
  max-height: 230px;
  overflow-y: auto;
  background: #FFFFFF;
  width: 100%;
}

.scl--cms-components-selectFieldInline-option {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 18px;
  gap: 10px;
  width: 100%;
  height: 30px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  box-sizing: border-box;
}

.scl--cms-components-selectFieldInline-option:hover {
  background-color: var(--scl--cms-components-selectFieldInline-option-hover-bg);
}

.scl--cms-components-selectFieldInline-option.scl--cms-components-selectFieldInline-option--selected {
  background-color: var(--scl--cms-components-selectFieldInline-option-selected-bg);
}

.scl--cms-components-selectFieldInline-optionIcon {
  display: none;
  width: 16px;
  height: 16px;
  flex: none;
  flex-grow: 0;
}

.scl--cms-components-selectFieldInline-optionIcon img {
  width: 16px;
  height: auto;
  object-fit: contain;
}

.scl--cms-components-selectFieldInline-optionLabel {
  font-family: var(--scl--default-font);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--scl--cms-components-selectFieldInline-border-color);
  flex: 1;
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: all 0.2s ease;
}

.scl--cms-components-selectFieldInline-option:hover .scl--cms-components-selectFieldInline-optionLabel {
  color: var(--typography-text-body-primary);
}

.scl--cms-components-selectFieldInline-noOptions {
  padding: 12px 10px;
  font-family: var(--scl--default-font);
  font-size: 14px;
  color: var(--scl--cms-components-selectFieldInline-border-color);
  text-align: center;
  width: 100%;
  box-sizing: border-box;
}

/* ─── Selected icon ──────────────────────────────────────────────────────────── */

.scl--cms-components-selectFieldInline-selectedIcon {
  width: 20px;
  height: 16px;
  flex: none;
  flex-grow: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}

.scl--cms-components-selectFieldInline-selectedIcon img {
  width: 20px;
  height: auto;
  object-fit: contain;
}

/* ─── Assistive text ─────────────────────────────────────────────────────────── */

.scl--cms-components-selectFieldInline-assistive {
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 2px 4px 2px 14px;
  height: 14px;
  font-family: var(--scl--default-font);
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: -0.15px;
  color: var(--scl--cms-components-selectFieldInline-assistive-text-color);
}

.scl--cms-components-selectFieldInline-assistive.scl--cms-components-selectFieldInline-assistive--error {
  color: var(--scl--cms-components-selectFieldInline-assistive-error-color);
}

/* ─── Custom scrollbar ───────────────────────────────────────────────────────── */

.scl--cms-components-selectFieldInline-options::-webkit-scrollbar {
  width: 4px;
}

.scl--cms-components-selectFieldInline-options::-webkit-scrollbar-track {
  background: var(--scl--cms-components-selectFieldInline-scrollbar-track-bg);
}

.scl--cms-components-selectFieldInline-options::-webkit-scrollbar-thumb {
  background: var(--scl--cms-components-selectFieldInline-scrollbar-thumb-bg);
  border-radius: 0px;
}

.scl--cms-components-selectFieldInline-options::-webkit-scrollbar-thumb:hover {
  background: var(--scl--cms-components-selectFieldInline-scrollbar-thumb-hover-bg);
}`, "",{"version":3,"sources":["webpack://./src/component-controller-mod/component-serv/input-fs-cp/select-field-op/css/selectFieldInline.css"],"names":[],"mappings":"AAAA;;CAEC;;AAED;EACE,uFAAuF;EACvF,qFAAqF;EACrF,0EAA0E;EAC1E,0EAA0E;EAC1E,0EAA0E;EAC1E,wGAAwG;EACxG,0EAA0E;EAC1E,uFAAuF;EACvF,0EAA0E;EAC1E,sFAAsF;EACtF,sFAAsF;EACtF,2FAA2F;EAC3F,0EAA0E;EAC1E,4FAA4F;EAC5F,0EAA0E;EAC1E,4FAA4F;EAC5F,0EAA0E;EAC1E,0EAA0E;EAC1E,0EAA0E;EAC1E,0EAA0E;AAC5E;;AAEA,mFAAmF;;AAEnF;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,mFAAmF;;AAEnF;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,2EAA2E;EAC3E,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iFAAiF;AACnF;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,8BAA8B;EAC9B,+BAA+B;EAC/B,oEAAoE;EACpE,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6EAA6E;AAC/E;;AAEA;EACE,6EAA6E;AAC/E;;AAEA;EACE,sEAAsE;EACtE,UAAU;AACZ;;AAEA;EACE,oEAAoE;EACpE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,mFAAmF;;AAEnF;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,kBAAkB;AACpB;;AAEA,mFAAmF;;AAEnF;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,OAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,mFAAmF;;AAEnF;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,qEAAqE;EACrE,OAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,mFAAmF;;AAEnF;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,iDAAiD;AACnD;;AAEA;EACE,kEAAkE;EAClE,4BAA4B;AAC9B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,mFAAmF;;AAEnF;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,oEAAoE;EACpE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,oFAAoF;EACpF,UAAU;EACV,2BAA2B;EAC3B,6EAA6E;EAC7E,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;EACnB,2EAA2E;AAC7E;;AAEA,mFAAmF;;AAEnF;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,yFAAyF;AAC3F;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;AACd;;AAEA;;EAEE,iEAAiE;AACnE;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,2EAA2E;EAC3E,UAAU;EACV,OAAO;EACP,YAAY;AACd;;AAEA;EACE,gEAAgE;AAClE;;AAEA,mFAAmF;;AAEnF;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,cAAc;EACd,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,8EAA8E;AAChF;;AAEA;EACE,iFAAiF;AACnF;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gEAAgE;EAChE,OAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,gEAAgE;EAChE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA,mFAAmF;;AAEnF;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA,mFAAmF;;AAEnF;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,wEAAwE;AAC1E;;AAEA;EACE,yEAAyE;AAC3E;;AAEA,mFAAmF;;AAEnF;EACE,UAAU;AACZ;;AAEA;EACE,2EAA2E;AAC7E;;AAEA;EACE,2EAA2E;EAC3E,kBAAkB;AACpB;;AAEA;EACE,iFAAiF;AACnF","sourcesContent":["/* SelectFieldInline Component Styles\n   Based on selectField.css — floating label removed, placeholder shown inline.\n*/\n\n:root {\n  --scl--cms-components-selectFieldInline-border-color:              var(--input-defualt);\n  --scl--cms-components-selectFieldInline-border-hover-color:        var(--input-hover);\n  --scl--cms-components-selectFieldInline-focus-color:               #2388FF;\n  --scl--cms-components-selectFieldInline-warning-color:             #FFC18E;\n  --scl--cms-components-selectFieldInline-error-color:               #F8868A;\n  --scl--cms-components-selectFieldInline-text-color:                var(--typography-text-body-secondary);\n  --scl--cms-components-selectFieldInline-placeholder-color:         #7D8187;\n  --scl--cms-components-selectFieldInline-chevron-color:             var(--input-defualt);\n  --scl--cms-components-selectFieldInline-dropdown-bg:               #FFFFFF;\n  --scl--cms-components-selectFieldInline-dropdown-shadow:           rgba(0, 0, 0, 0.12);\n  --scl--cms-components-selectFieldInline-option-hover-bg:           var(--action-hover);\n  --scl--cms-components-selectFieldInline-option-selected-bg:        rgba(125, 129, 135, 0.2);\n  --scl--cms-components-selectFieldInline-required-color:            #EB5252;\n  --scl--cms-components-selectFieldInline-search-border-color:       rgba(255, 255, 255, 0.05);\n  --scl--cms-components-selectFieldInline-search-input-text-color:   #FFFFFF;\n  --scl--cms-components-selectFieldInline-assistive-text-color:      rgba(255, 255, 255, 0.54);\n  --scl--cms-components-selectFieldInline-assistive-error-color:     #FF5252;\n  --scl--cms-components-selectFieldInline-scrollbar-track-bg:        #393939;\n  --scl--cms-components-selectFieldInline-scrollbar-thumb-bg:        #1C1C1C;\n  --scl--cms-components-selectFieldInline-scrollbar-thumb-hover-bg:  #7D8187;\n}\n\n/* ─── Container ──────────────────────────────────────────────────────────────── */\n\n.scl--cms-components-selectFieldInline-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 0px;\n  width: 100%;\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n  position: relative;\n}\n\n/* ─── Plate ──────────────────────────────────────────────────────────────────── */\n\n.scl--cms-components-selectFieldInline-plate {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  width: 100%;\n  height: 32px;\n  border: 1px solid var(--scl--cms-components-selectFieldInline-border-color);\n  border-radius: 3px;\n  cursor: pointer;\n  transition: border-color 0.3s ease;\n  position: relative;\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n}\n\n.scl--cms-components-selectFieldInline-plate:hover {\n  border: 1px solid var(--scl--cms-components-selectFieldInline-border-hover-color);\n}\n\n/* Bottom focus accent bar */\n.scl--cms-components-selectFieldInline-plate::after {\n  content: '';\n  position: absolute;\n  left: -1px;\n  bottom: -1px;\n  width: calc(100% + 2px);\n  height: 4px;\n  border-bottom-left-radius: 3px;\n  border-bottom-right-radius: 3px;\n  background: var(--scl--cms-components-selectFieldInline-focus-color);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.scl--cms-components-selectFieldInline-plate.scl--cms-components-selectFieldInline--open::after {\n  opacity: 1;\n}\n\n.scl--cms-components-selectFieldInline-plate:hover:not(.scl--cms-components-selectFieldInline--open) {\n  border-color: var(--scl--cms-components-selectFieldInline-border-hover-color);\n}\n\n.scl--cms-components-selectFieldInline-plate.scl--cms-components-selectFieldInline--open {\n  border-color: var(--scl--cms-components-selectFieldInline-border-hover-color);\n}\n\n.scl--cms-components-selectFieldInline-plate.scl--cms-components-selectFieldInline--warning::after {\n  background: var(--scl--cms-components-selectFieldInline-warning-color);\n  opacity: 1;\n}\n\n.scl--cms-components-selectFieldInline-plate.scl--cms-components-selectFieldInline--error::after {\n  background: var(--scl--cms-components-selectFieldInline-error-color);\n  opacity: 1;\n}\n\n.scl--cms-components-selectFieldInline-plate.scl--cms-components-selectFieldInline--disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ─── Wrapper ────────────────────────────────────────────────────────────────── */\n\n.scl--cms-components-selectFieldInline-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0px 12px;\n  gap: 12px;\n  width: 100%;\n  height: 32px;\n  flex: 1;\n  order: 0;\n  flex-grow: 1;\n  box-sizing: border-box;\n}\n\n.scl--cms-components-selectFieldInline-valueWrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0;\n  height: 100%;\n  flex: 1;\n  order: 1;\n  flex-grow: 1;\n}\n\n.scl--cms-components-selectFieldInline-textWrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0px;\n  width: 100%;\n  height: 100%;\n  flex: 1;\n  order: 0;\n  flex-grow: 1;\n  position: relative;\n}\n\n/* ─── Selected value text ────────────────────────────────────────────────────── */\n\n.scl--cms-components-selectFieldInline-text {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  font-family: var(--scl--default-font);\n  font-style: light;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0.50px;\n  color: var(--input-hover);\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* ─── Placeholder (replaces floating label) ──────────────────────────────────── */\n\n.scl--cms-components-selectFieldInline-placeholder {\n  font-family: var(--scl--default-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0.25px;\n  color: var(--scl--cms-components-selectFieldInline-placeholder-color);\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  pointer-events: none;\n}\n\n/* ─── Chevron ────────────────────────────────────────────────────────────────── */\n\n.scl--cms-components-selectFieldInline-chevronIcon {\n  width: 16px;\n  height: 16px;\n  flex: none;\n  order: 1;\n  transition: transform 0.3s ease, stroke 0.3s ease;\n}\n\n.scl--cms-components-selectFieldInline-chevronIcon path {\n  stroke: var(--scl--cms-components-selectFieldInline-chevron-color);\n  transition: stroke 0.3s ease;\n}\n\n.scl--cms-components-selectFieldInline-plate.scl--cms-components-selectFieldInline--open\n.scl--cms-components-selectFieldInline-chevronIcon {\n  transform: rotate(180deg);\n}\n\n/* ─── Dropdown ───────────────────────────────────────────────────────────────── */\n\n.scl--cms-components-selectFieldInline-dropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 0;\n  right: 0;\n  background: var(--scl--cms-components-selectFieldInline-dropdown-bg);\n  border-radius: 2px;\n  min-width: 115px;\n  max-height: 280px;\n  overflow: auto;\n  z-index: 1000;\n  box-shadow: 0px 4px 4px var(--scl--cms-components-selectFieldInline-dropdown-shadow);\n  opacity: 0;\n  transform: translateY(-6px);\n  transition: opacity 0.2s ease, transform 0.2s ease, visibility 0s linear 0.2s;\n  pointer-events: none;\n  visibility: hidden;\n}\n\n.scl--cms-components-selectFieldInline-dropdown.scl--cms-components-selectFieldInline-dropdown--open {\n  opacity: 1;\n  transform: translateY(0px);\n  pointer-events: auto;\n  visibility: visible;\n  transition: opacity 0.2s ease, transform 0.2s ease, visibility 0s linear 0s;\n}\n\n/* ─── Search ─────────────────────────────────────────────────────────────────── */\n\n.scl--cms-components-selectFieldInline-search {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 8px 17px;\n  gap: 14px;\n  width: 100%;\n  height: 37px;\n  border-bottom: 1px solid var(--scl--cms-components-selectFieldInline-search-border-color);\n}\n\n.scl--cms-components-selectFieldInline-searchIcon {\n  width: 20px;\n  height: 17px;\n  flex: none;\n  flex-grow: 0;\n}\n\n.scl--cms-components-selectFieldInline-searchIcon path,\n.scl--cms-components-selectFieldInline-searchIcon ellipse {\n  stroke: var(--scl--cms-components-selectFieldInline-border-color);\n}\n\n.scl--cms-components-selectFieldInline-searchInput {\n  width: 100%;\n  background: transparent;\n  border: none;\n  outline: none;\n  font-family: var(--scl--default-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 21px;\n  color: var(--scl--cms-components-selectFieldInline-search-input-text-color);\n  padding: 0;\n  flex: 1;\n  flex-grow: 1;\n}\n\n.scl--cms-components-selectFieldInline-searchInput::placeholder {\n  color: var(--scl--cms-components-selectFieldInline-border-color);\n}\n\n/* ─── Options ────────────────────────────────────────────────────────────────── */\n\n.scl--cms-components-selectFieldInline-options {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  padding: 7px 0;\n  gap: 0px;\n  max-height: 230px;\n  overflow-y: auto;\n  background: #FFFFFF;\n  width: 100%;\n}\n\n.scl--cms-components-selectFieldInline-option {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 10px 18px;\n  gap: 10px;\n  width: 100%;\n  height: 30px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  box-sizing: border-box;\n}\n\n.scl--cms-components-selectFieldInline-option:hover {\n  background-color: var(--scl--cms-components-selectFieldInline-option-hover-bg);\n}\n\n.scl--cms-components-selectFieldInline-option.scl--cms-components-selectFieldInline-option--selected {\n  background-color: var(--scl--cms-components-selectFieldInline-option-selected-bg);\n}\n\n.scl--cms-components-selectFieldInline-optionIcon {\n  display: none;\n  width: 16px;\n  height: 16px;\n  flex: none;\n  flex-grow: 0;\n}\n\n.scl--cms-components-selectFieldInline-optionIcon img {\n  width: 16px;\n  height: auto;\n  object-fit: contain;\n}\n\n.scl--cms-components-selectFieldInline-optionLabel {\n  font-family: var(--scl--default-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: var(--scl--cms-components-selectFieldInline-border-color);\n  flex: 1;\n  flex-grow: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  transition: all 0.2s ease;\n}\n\n.scl--cms-components-selectFieldInline-option:hover .scl--cms-components-selectFieldInline-optionLabel {\n  color: var(--typography-text-body-primary);\n}\n\n.scl--cms-components-selectFieldInline-noOptions {\n  padding: 12px 10px;\n  font-family: var(--scl--default-font);\n  font-size: 14px;\n  color: var(--scl--cms-components-selectFieldInline-border-color);\n  text-align: center;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* ─── Selected icon ──────────────────────────────────────────────────────────── */\n\n.scl--cms-components-selectFieldInline-selectedIcon {\n  width: 20px;\n  height: 16px;\n  flex: none;\n  flex-grow: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 10px;\n}\n\n.scl--cms-components-selectFieldInline-selectedIcon img {\n  width: 20px;\n  height: auto;\n  object-fit: contain;\n}\n\n/* ─── Assistive text ─────────────────────────────────────────────────────────── */\n\n.scl--cms-components-selectFieldInline-assistive {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 2px 4px 2px 14px;\n  height: 14px;\n  font-family: var(--scl--default-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 12px;\n  letter-spacing: -0.15px;\n  color: var(--scl--cms-components-selectFieldInline-assistive-text-color);\n}\n\n.scl--cms-components-selectFieldInline-assistive.scl--cms-components-selectFieldInline-assistive--error {\n  color: var(--scl--cms-components-selectFieldInline-assistive-error-color);\n}\n\n/* ─── Custom scrollbar ───────────────────────────────────────────────────────── */\n\n.scl--cms-components-selectFieldInline-options::-webkit-scrollbar {\n  width: 4px;\n}\n\n.scl--cms-components-selectFieldInline-options::-webkit-scrollbar-track {\n  background: var(--scl--cms-components-selectFieldInline-scrollbar-track-bg);\n}\n\n.scl--cms-components-selectFieldInline-options::-webkit-scrollbar-thumb {\n  background: var(--scl--cms-components-selectFieldInline-scrollbar-thumb-bg);\n  border-radius: 0px;\n}\n\n.scl--cms-components-selectFieldInline-options::-webkit-scrollbar-thumb:hover {\n  background: var(--scl--cms-components-selectFieldInline-scrollbar-thumb-hover-bg);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
